<template>
  <div class="reporte-fisico-vista">
    <div v-if="errorCarga" class="reporte-fisico-estado" role="alert">
      <p>No se pudo cargar la información del contrato.</p>
      <v-btn outlined color="primary" @click="reintentar">Reintentar</v-btn>
    </div>
    <skeleton-reporte
      v-else-if="mostrarSkeleton" />
    <div v-else-if="!contratoDisponible" class="reporte-fisico-estado" role="status">
      <p>Contrato no disponible.</p>
    </div>
    <!-- Todo el contenido dinámico se escapa en crearDocumentoReporteFisico. -->
    <div v-else ref="contenido" v-html="documento"></div>
  </div>
</template>

<script>
import SkeletonReporte from '@/components/administracion/ejecucion/reportes/documento/SkeletonReporte.vue';
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import { crearDocumentoReporteFisico } from '@/components/administracion/ejecucion/reportes/documento/reporteFisico';

export default {
  name: 'MainContratoReporteFisico',
  components: { SkeletonReporte },
  props: {
    cargandoContrato: { type: Boolean, default: false },
    cargandoCatalogo: { type: Boolean, default: false },
    reporteFisico: { type: Object, required: true },
    contratoReporte: { type: Object, default: null },
    catalogoConceptos: { type: Array, default: () => [] },
  },
  data: () => ({ contrato: null, errorCarga: false, limpiarImagenes: null }),
  apollo: {
    contrato: {
      query: CONTRATO,
      skip() { return !!this.contratoReporte; },
      variables() { return { id: this.$route.params.idContrato }; },
      error() { this.errorCarga = true; },
      result() { this.errorCarga = false; },
    },
  },
  computed: {
    contratoDisponible() { return this.contratoReporte || this.contrato; },
    mostrarSkeleton() {
      return this.cargandoCatalogo
        || (!this.contratoDisponible && (this.cargandoContrato || this.$apollo.loading));
    },
    documento() {
      if (!this.contratoDisponible || this.cargandoCatalogo) return '';
      return crearDocumentoReporteFisico({
        contrato: this.contratoDisponible,
        reporte: this.reporteFisico,
        encabezado: this.mixGeneraEncabezadosPdf(this.reporteFisico.fecha, []),
        colores: this.$vuetify.theme.themes.light,
        servidorArchivos: this.$urlFileServer,
        catalogoConceptos: this.catalogoConceptos,
      });
    },
  },
  watch: {
    documento: {
      immediate: true,
      handler(valor) {
        this.$emit('documento', valor);
        this.$nextTick(this.prepararImagenes);
      },
    },
  },
  beforeDestroy() {
    if (this.limpiarImagenes) this.limpiarImagenes();
  },
  methods: {
    prepararImagenes() {
      if (this.limpiarImagenes) this.limpiarImagenes();
      const { contenido } = this.$refs;
      if (!contenido) return;
      const limpiezas = Array.from(contenido.querySelectorAll('.rf-foto img')).map((imagen) => {
        const marco = imagen.parentElement;
        const terminar = () => {
          marco.classList.remove('rf-imagen-cargando');
          marco.setAttribute('aria-busy', 'false');
        };
        if (!imagen.complete) {
          marco.classList.add('rf-imagen-cargando');
          marco.setAttribute('aria-busy', 'true');
          imagen.addEventListener('load', terminar);
          imagen.addEventListener('error', terminar);
        } else {
          terminar();
        }
        return () => {
          imagen.removeEventListener('load', terminar);
          imagen.removeEventListener('error', terminar);
        };
      });
      this.limpiarImagenes = () => limpiezas.forEach((limpiar) => limpiar());
    },
    reintentar() {
      this.errorCarga = false;
      this.$apollo.queries.contrato.refetch().catch(() => { this.errorCarga = true; });
    },
  },
};
</script>

<style scoped>
.reporte-fisico-estado { padding: 48px 24px; text-align: center; }
.reporte-fisico-estado p { margin-top: 16px; }
</style>
